<a
  *ngIf="routerLink"
  routerLinkActive="active"
  [routerLink]="routerLink"
  [queryParams]="utmParams"
  class="news-link">
  <ng-template [ngTemplateOutlet]="linkContent"></ng-template>
</a>
<ng-container *ngIf="!routerLink">
  <ng-template [ngTemplateOutlet]="linkContent"></ng-template>
</ng-container>
<ng-template #linkContent>
  <div class="layout {{ layout }}"
       [class.no-content]="!showContent"
       [class.left-align]="splitAlignment == ContentCardAlignment.Left">
    <img *ngIf="showVideoIndicator"
         src="assets/icons/play-circle.svg"
         alt="Play video"
         class="video-indicator"
         [class.left-align]="splitAlignment == ContentCardAlignment.Left"
    />
    <lib-lazy-image
      [preload]="preloadImage"
      [lazyLoad]="lazyLoadImage"
      [picture]="picture"
      [targetRes]="imageResolution"
      [style.object-fit]="containImage ? 'contain' : 'cover'"
      [style.max-height]="getMaxImageHeight()"
      [style.min-height]="minImageHeight"
      [style.aspect-ratio]="aspectRatio"
      alt="Top news"
      class="image"></lib-lazy-image>
    <div *ngIf="layout === 'full'" class="abo-chip">
      <ng-content select="[aboChip]"></ng-content>
    </div>
    <div *ngIf="showGradient" class="gradient"></div>
    <div *ngIf="showContent && title" class="content {{colorScheme.main}}">
      <small *ngIf="preTitle?.length > 0"
             class="{{colorScheme.accent}}"
             [innerHTML]="preTitle"
      ></small>
      <h3 *ngIf="title"
          [innerHTML]="title"></h3>
      <h3 *ngIf="!title" [innerHTML]="preview_text"></h3>
      <div class="content-footer">
        <ng-content select="[footerContent]"></ng-content>
      </div>
    </div>
  </div>
</ng-template>
